export const EXTERNAL_LOGIN_ENTER_CONTACT = {
  title: 'Add your phone number to receive more timely updates!',
  connected_to_fb: 'Connected To Facebook',
  phone_input: 'Phone Number',
  save_button: 'Save',
};
